module.exports = __webpack_public_path__ + "img/Cove specs.d6f1c453.jpg";